<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>FABRICATION</h1>
        </div>
      </div>
    </div>
    <section>
      <div class="tabs tabs-style-linebox">
        <div class="zznav hidden-xs">
          <ul class="zzitem">
            <li><a @click="forId('gcjs')">Factory Introduction</a></li>
            <li><a @click="forId('pzjc')">Quality Inspection</a></li>
            <li><a @click="forId('cpbz')">Product Packaging</a></li>
            <li><a @click="forId('cpdb')">Product Features</a></li>
          </ul>
        </div>
        <!-- 小滚轮 -->
        <div id="ss_menu">
          <div>
            <i
              ><a @click="forId('gcjs')">Factory<br />Introduction</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('pzjc')">Quality<br />Inspection</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('cpbz')">Product<br />Packaging</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('cpdb')">Product<br />Features</a></i
            >
          </div>
          <div class="menu">
            <div class="share" id="ss_toggle" data-rot="180">
              <div class="circle"></div>
              <div class="bar"></div>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <section id="gcjs">
            <!-- 图片 -->
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>Factory Introduction</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                HUAYIN Group has a manufacturing plants with advanced
                technology, respectively located in Haian Jiangsu. Our plants
                have area of 125,000 sqm in total while workshops take up 63,000
                sqm , and our annual production capacity is 50,000 tons.
              </p>
            </div>

            <div class="seboxTitle">Workshop Introduction</div>
            <section class="page-wrapper effect-1st" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-first">
                  <div class="image">
                    <img v-lazy="hyzz1" alt="Lazy-loaded Image" />
                    <div class="overlay"></div>
                  </div>
                  <div class="content">
                    <h2>Production Workshop<br />Area: 28000 sq.m</h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <!-- COIDEA:demo:effect-1st END -->

            <!-- COIDEA:demo:effect-2nd START -->
            <section class="page-wrapper effect-2nd" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-second">
                  <div class="image">
                    <img v-lazy="hyzz2" alt="Lazy-loaded Image" />
                    <div class="overlay1"></div>
                    <div class="overlay2"></div>
                    <div class="overlay3"></div>
                  </div>
                  <div class="content">
                    <h2>Painting Shop<br />Area: 10000 sq.m</h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <!-- COIDEA:demo:effect-2nd END -->

            <!-- COIDEA:demo:effect-3rd START -->
            <section class="page-wrapper effect-3rd" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-third">
                  <div class="image">
                    <img v-lazy="hyzz3" alt="Lazy-loaded Image" />
                    <div class="overlay1"></div>
                    <div class="overlay2"></div>
                    <div class="overlay3"></div>
                  </div>
                  <div class="content">
                    <h2>
                      <span>Finished Product</span><br />Area: 15000 sq.m<br />Lifting
                      Weight: 20T<br />Lifting Height: 8M<br />Quantity: Two
                    </h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <div class="seboxTitle">Equipment Introduction</div>
            <div class="seboxlist animate__animated animate__fadeIn">
              <div class="row">
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz4" alt="Lazy-loaded Image" class="cmn" />
                    <p>robot welding</p>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz5" alt="Lazy-loaded Image" />
                        <p>sand blasting machine</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz6" alt="Lazy-loaded Image" />
                        <p>saw welder</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4" style="padding-left: 0">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz7" alt="Lazy-loaded Image" />
                        <p>cnc drilling machine</p>
                      </div>
                    </div>
                    <div class="col-md-8" style="padding-right: 15px">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz8" alt="Lazy-loaded Image" />
                        <p>bipolar submerged arc welding machine</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz9" alt="Lazy-loaded Image" class="cmn" />
                    <p>cnc plasma steel cutting machine</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz10" alt="Lazy-loaded Image" />
                        <p>laser cutting machine</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz11" alt="Lazy-loaded Image" />
                        <p>laser cutting</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz12" alt="Lazy-loaded Image" />
                    <p>CNC drilling machine</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域2的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz13" alt="Lazy-loaded Image" />
                    <p>environmental spray booth</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz14" alt="Lazy-loaded Image" class="cmn" />
                    <p>assembly machine</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz15" alt="Lazy-loaded Image" class="cmn" />
                    <p>electroslag welding</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz16" alt="Lazy-loaded Image" />
                        <p>material storage</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz17" alt="Lazy-loaded Image" />
                        <p>multi door flame cutting machine</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz18" alt="Lazy-loaded Image" />
                        <p>nc plasma cutting</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 品质检测 -->
          <section id="pzjc">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>Quality Inspection</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                HUAYIN focuses on every process from raw materials to the
                finished products, using our strict process and quality control.
                We closely work together with our customers to ensure all steel
                members be made with special care.
              </p>
            </div>

            <div class="seboxlist">
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz19" alt="Lazy-loaded Image" />
                    <p>BH column assembly self test</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz20" alt="Lazy-loaded Image" />
                    <p>welder examination</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz21" alt="Lazy-loaded Image" />
                    <p>party a inspection</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz22" alt="Lazy-loaded Image" />
                    <p>quality review</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz23" alt="Lazy-loaded Image" />
                    <p>laboratory</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz24" alt="Lazy-loaded Image" />
                    <p>raw material stacking</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 产品包装 -->
          <section id="cpbz">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>Product Packaging</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                In order to ensure each member well protected during the
                delivery time, we pack the finished products according to
                customers' requirements, transportation distance and style. Our
                excellent packing methods can avoid any damage caused to the
                steel members during delivery, and ensure our products can be
                shipped to any remote sites , we had exported to the locations
                like : USA, Japan, EU, Australia, Korea, Thailand, South Africa,
                Haiti, Angola, etc.
              </p>
            </div>

            <div class="seboxlist">
              <div class="row">
                <div class="col-md-8">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz25" alt="Lazy-loaded Image" class="cmn" />
                    <p>overseas transport</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域1的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz26" alt="Lazy-loaded Image" />
                        <p>structural transport</p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域1的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz27" alt="Lazy-loaded Image" />
                        <p>component detection</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz28" alt="Lazy-loaded Image" />
                    <p>component packaging</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz29" alt="Lazy-loaded Image" />
                    <p>package connection</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz30" alt="Lazy-loaded Image" />
                    <p>component overview</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 产品对比 -->
          <section id="cpdb">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>Product Features</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <carousel-3d
              :controlsVisible="true"
              :width="cWidth"
              :height="cHeight"
              :display="cNum"
              :space="280"
            >
              <slide
                v-lazy-container="{ selector: 'img' }"
                :index="index"
                v-for="(item, index) in List"
                :key="index"
              >
                <div class="col-md-12 col-xs-12">
                  <h2 style="text-align: center">{{ item.title }}</h2>
                  <div class="col-md-6">
                    <img :data-src="item.img1" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt1 }}</p>
                  </div>
                  <div class="col-md-6">
                    <img :data-src="item.img2" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt2 }}</p>
                  </div>
                </div>
                <p
                  class="slideP"
                  style="
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                  "
                >
                  {{ index + 1 }} page/23 Pages
                </p>
              </slide>
            </carousel-3d>
          </section>
        </div>
        <!-- /content -->
      </div>
      <!-- /tabs -->
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import ScrollMagic from 'scrollmagic'
import gsap from 'gsap'
import { TweenMax } from 'gsap'
import 'bootstrap/dist/js/bootstrap.js'
export default {
  data() {
    return {
      List: [
        {
          title: 'Raw Material Management',
          img1: require('@/components/img/hyzz/cpdb1.jpg'),
          txt1: 'Common problems: Raw materials are randomly placed, different materials are not differentiated, and workers are easy to take and use.',
          img2: require('@/components/img/hyzz/cpdb1-1.jpg'),
          txt2: 'HuaYin: There is a suitable storage location and the material method is neat.',
        },
        {
          title: 'Color And Bar Code Management',
          img1: require('@/components/img/hyzz/cpdb2.jpg'),
          txt1: 'Common problems: the material is not marked, and it is easy to make mistakes.',
          img2: require('@/components/img/hyzz/cpdb2-1.jpg'),
          txt2: 'HuaYin:different steel grades are painted with color brush to distinguish',
        },
        {
          title: 'Raw Material Supplier',
          img1: require('@/components/img/hyzz/cpdb3.jpg'),
          txt1: 'Common problem: Choose a steel mill without any logo, which belongs to the "three no" products.',
          img2: require('@/components/img/hyzz/cpdb3-1.jpg'),
          txt2: 'Huayin: Choose the domestic brand steel: Shougang, Ma Steel and so on.',
        },
        {
          title: 'Steel Plate Cutting Quality',
          img1: require('@/components/img/hyzz/cpdb4.jpg'),
          txt1: 'Common problems: The cutting surface is uneven, there are serrated defects, and the appearance quality is very poor.',
          img2: require('@/components/img/hyzz/cpdb4-1.jpg'),
          txt2: 'Huayin: CNC cutting, cutting surface quality is good.',
        },
        {
          title: 'Free Chamfer Grinding',
          img1: require('@/components/img/hyzz/cpdb5.jpg'),
          txt1: 'Common problems: Free not to do chamfer grinding, there are burrs not removed.',
          img2: require('@/components/img/hyzz/cpdb5-1.jpg'),
          txt2: 'HuaYin: All cutting surfaces and free edges are chamfered and polished.',
        },
        {
          title: 'Guide Plate Arc',
          img1: require('@/components/img/hyzz/cpdb6.jpg'),
          txt1: 'Common problem: no arc plate installed.',
          img2: require('@/components/img/hyzz/cpdb6-1.jpg'),
          txt2: 'HuaYin: BH submerged arc welding seam installation arc plate.',
        },
        {
          title: 'Chamfer',
          img1: require('@/components/img/hyzz/cpdb7.jpg'),
          txt1: 'Common problems: bolt holes have burrs that affect the adhesion of the paint',
          img2: require('@/components/img/hyzz/cpdb7-1.jpg'),
          txt2: 'Huayin: All bolt holes are chamfered and polished',
        },
        {
          title: 'Over Weld Hole Chamfer',
          img1: require('@/components/img/hyzz/cpdb8.jpg'),
          txt1: 'Common problems: do not open the welding hole, the intersection of the three welds is very poor, there are arc pit defects',
          img2: require('@/components/img/hyzz/cpdb8-1.jpg'),
          txt2: 'Huayin: There are overweld holes at the intersection of main welds to prevent stress concentration, and the fillet welds are qualified.',
        },
        {
          title: 'Position Welding',
          img1: require('@/components/img/hyzz/cpdb9.jpg'),
          txt1: 'Common problem: No process requirements, spot welding at will.',
          img2: require('@/components/img/hyzz/cpdb9-1.jpg'),
          txt2: 'Huayin: There are technical requirements for spot welding fixed, the length is required to be 100~150, and the spacing is 300~400.',
        },
        {
          title: 'Submerged Arc Welding',
          img1: require('@/components/img/hyzz/cpdb10.jpg'),
          txt1: 'Common problems: the size of welding Angle is not uniform, and the smooth transition and effective fusion between the welding pass and the base material are not smooth',
          img2: require('@/components/img/hyzz/cpdb10-1.jpg'),
          txt2: 'HuaYin: The weld is smooth and transitional, the appearance is very beautiful, and there are no weld defects.',
        },
        {
          title: 'Internal Section View Of Weld',
          img1: require('@/components/img/hyzz/cpdb11.jpg'),
          txt1: 'Common problem: After the internal section of the weld, there is no fusion.',
          img2: require('@/components/img/hyzz/cpdb11-1.jpg'),
          txt2: 'HuaYin: After the internal section of the weld, it is completely fused',
        },
        {
          title: 'Steel Alignment',
          img1: require('@/components/img/hyzz/cpdb12.jpg'),
          txt1: 'Common problems: distortion after welding, do not do correction treatment.',
          img2: require('@/components/img/hyzz/cpdb12-1.jpg'),
          txt2: 'HuaYin: After correction, it meets the standard requirements.',
        },
        {
          title: 'Slice',
          img1: require('@/components/img/hyzz/cpdb13.jpg'),
          txt1: 'Common problems: manual cutting is not straight, deep cut, slag is not removed.',
          img2: require('@/components/img/hyzz/cpdb13-1.jpg'),
          txt2: 'HuaYin: The machine cuts straight and smooth, without defects.',
        },
        {
          title: 'Platform Beam Making',
          img1: require('@/components/img/hyzz/cpdb14.jpg'),
          txt1: 'Common problem: Manual cutting, no R Angle.',
          img2: require('@/components/img/hyzz/cpdb14-1.jpg'),
          txt2: 'HuaYin: Exposed R Angle smooth transition.',
        },
        {
          title: 'submerged arc automatic welding',
          img1: require('@/components/img/hyzz/cpdb15.jpg'),
          txt1: 'Common problems: Domestic submerged arc welding machine welding quality is very poor.',
          img2: require('@/components/img/hyzz/cpdb15-1.jpg'),
          txt2: 'HuaYin: The imported submerged arc welding machine is very advanced, and the welding quality is very good',
        },
        {
          title: 'Fracture Surface Cutting',
          img1: require('@/components/img/hyzz/cpdb16.jpg'),
          txt1: 'Common problems: The cutting surface is not straight, there are gaps.',
          img2: require('@/components/img/hyzz/cpdb16-1.jpg'),
          txt2: 'HuaYin: The cutting surface is smooth and smooth.',
        },
        {
          title: 'Assembly Technology',
          img1: require('@/components/img/hyzz/cpdb17.jpg'),
          txt1: 'Common problem: No assembly process requirements.',
          img2: require('@/components/img/hyzz/cpdb17-1.jpg'),
          txt2: 'HuaYin: Open the groove according to the production process, grinding and assembling',
        },
        {
          title: 'Smaw Weld',
          img1: require('@/components/img/hyzz/cpdb18.jpg'),
          txt1: 'Common problems: The weld is rough and the molding is poor.',
          img2: require('@/components/img/hyzz/cpdb18-1.jpg'),
          txt2: 'HuaYin: The welds are smooth and neat.',
        },
        {
          title: 'Multipass Welding',
          img1: require('@/components/img/hyzz/cpdb19.jpg'),
          txt1: 'Common problem: No fusion between bead and bead.',
          img2: require('@/components/img/hyzz/cpdb19-1.jpg'),
          txt2: 'HuaYin: Smooth and neat between the bead and the bead.',
        },
        {
          title: 'GMAW Welding',
          img1: require('@/components/img/hyzz/cpdb20.jpg'),
          txt1: 'Common problems: The weld molding is rough and the appearance is defective.',
          img2: require('@/components/img/hyzz/cpdb20-1.jpg'),
          txt2: 'HuaYin: The weld forming is beautiful and smooth.',
        },
        {
          title: 'Shot Blasting And Rust Removal',
          img1: require('@/components/img/hyzz/cpdb21.jpg'),
          txt1: 'Common problem: Rust removal grade is not thorough.',
          img2: require('@/components/img/hyzz/cpdb21-1.jpg'),
          txt2: 'HuaYin: The rust removal grade reaches Sa2 ½.',
        },
        {
          title: 'Spray Paint Quality',
          img1: require('@/components/img/hyzz/cpdb22.jpg'),
          txt1: 'Common problems: paint multiple scratches, uneven paint thickness.',
          img2: require('@/components/img/hyzz/cpdb22-1.jpg'),
          txt2: 'HuaYin: The paint coating is uniform, no defects in appearance.',
        },
        {
          title: 'Friction Surface Sticker Protection',
          img1: require('@/components/img/hyzz/cpdb23.jpg'),
          txt1: 'Common problem: Friction surface does not sticker, paint.',
          img2: require('@/components/img/hyzz/cpdb23-1.jpg'),
          txt2: 'huayin friction surface according to the standard sticker',
        },
      ],
      hyzz1: require('@/components/img/hyzz/cjjs1.png'),
      hyzz2: require('@/components/img/hyzz/cjjs2.png'),
      hyzz3: require('@/components/img/hyzz/cjjs3.png'),
      hyzz4: require('@/components/img/hyzz/sbjs1.png'),
      hyzz5: require('@/components/img/hyzz/sbjs2.png'),
      hyzz6: require('@/components/img/hyzz/sbjs3.jpg'),
      hyzz7: require('@/components/img/hyzz/sbjs4.jpg'),
      hyzz8: require('@/components/img/hyzz/sbjs5.jpg'),
      hyzz9: require('@/components/img/hyzz/sbjs6.jpg'),
      hyzz10: require('@/components/img/hyzz/sbjs7.png'),
      hyzz11: require('@/components/img/hyzz/sbjs8.jpg'),
      hyzz12: require('@/components/img/hyzz/sbjs9.jpg'),
      hyzz13: require('@/components/img/hyzz/sbjs10.png'),
      hyzz14: require('@/components/img/hyzz/sbjs11.jpg'),
      hyzz15: require('@/components/img/hyzz/sbjs12.jpg'),
      hyzz16: require('@/components/img/hyzz/sbjs13.jpg'),
      hyzz17: require('@/components/img/hyzz/sbjs14.jpg'),
      hyzz18: require('@/components/img/hyzz/sbjs15.jpg'),
      hyzz19: require('@/components/img/hyzz/pzjc1.jpg'),
      hyzz20: require('@/components/img/hyzz/pzjc2.jpg'),
      hyzz21: require('@/components/img/hyzz/pzjc3.jpg'),
      hyzz22: require('@/components/img/hyzz/pzjc4.jpg'),
      hyzz23: require('@/components/img/hyzz/pzjc5.jpg'),
      hyzz24: require('@/components/img/hyzz/pzjc6.jpg'),
      hyzz25: require('@/components/img/hyzz/cpbz1.jpg'),
      hyzz26: require('@/components/img/hyzz/cpbz2.jpg'),
      hyzz27: require('@/components/img/hyzz/cpbz3.jpg'),
      hyzz28: require('@/components/img/hyzz/cpbz4.jpg'),
      hyzz29: require('@/components/img/hyzz/cpbz5.jpg'),
      hyzz30: require('@/components/img/hyzz/cpbz6.jpg'),
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }
    // 图片

    $(document).ready(function () {
      // Controller
      var controller = new ScrollMagic.Controller({
        loglevel: 3,
      })

      // Set Variables
      TweenMax.set('.grid-item .image', {
        perspective: 500,
      })
      TweenMax.set('.grid-item .image .overlay', {
        z: 150,
      })
      TweenMax.set('.grid-item .image .content h2', {
        z: 151,
        autoAlpha: 0,
      })

      // grid-item with effect-first
      var timelineEffectFirst = new gsap.timeline({
        paused: true,
      })
      timelineEffectFirst
        .fromTo(
          '.effect-first .image .overlay',
          1,
          {
            skewX: -10,
            scale: 1.15,
          },
          {
            delay: 1,
            skewX: 20,
            xPercent: 85,
            transformOrigin: '0% 100%',
          }
        )
        .from(
          '.effect-first .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1'
        )
        .fromTo(
          '.effect-first .content > h2',
          0.75,
          {
            autoAlpha: 0,
            x: -128,
          },
          {
            autoAlpha: 1,
            x: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-first',
        triggerHook: 0.8,
        offset: 60,
      })
        .addTo(controller)
        .setTween(timelineEffectFirst.play())

      // grid-item with effect-second
      var timelineEffectSecond = new gsap.timeline({
        paused: true,
      })
      timelineEffectSecond
        .fromTo(
          '.effect-second .image .overlay1',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          }
        )
        .fromTo(
          '.effect-second .image .overlay2',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          },
          '-=0.85'
        )
        .fromTo(
          '.effect-second .image .overlay3',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          },
          '-=0.75'
        )
        .from(
          '.effect-second .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1.25'
        )
        .fromTo(
          '.effect-second .content > h2',
          0.75,
          {
            autoAlpha: 0,
            x: -128,
          },
          {
            autoAlpha: 1,
            x: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-second',
        triggerHook: 0.8,
      })
        .addTo(controller)
        .setTween(timelineEffectSecond.play())

      // grid-item with effect-third
      var timelineEffectThird = new gsap.timeline({
        paused: true,
      })
      timelineEffectThird
        .fromTo(
          '.effect-third .image .overlay1',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          }
        )
        .fromTo(
          '.effect-third .image .overlay2',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          },
          '-=0.85'
        )
        .fromTo(
          '.effect-third .image .overlay3',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          },
          '-=0.75'
        )
        .from(
          '.effect-third .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1.25'
        )
        .fromTo(
          '.effect-third .content > h2',
          0.75,
          {
            autoAlpha: 0,
            y: -128,
          },
          {
            autoAlpha: 1,
            y: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-third',
        triggerHook: 0.8,
      })
        .addTo(controller)
        .setTween(timelineEffectThird.play())
    })
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
    //根据电脑分辨率设置轮播图宽度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1400
        this.cHeight = 800
        this.cNum = 5
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 1200
        this.cHeight = 600
        this.cNum = 3
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1200
        this.cHeight = 1700
        this.cNum = 3
      }
    },
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style scoped>
@import url('./css/tabs.css');
@import url('./css/tabstyles.css');
@import url('./css/fontAwesome.css');
#gcjs,
#pzjc,
#cpbz,
#cpdb {
  margin-top: -83px;
  padding-top: 83px;
}
.seboxp {
  padding: 5px;
}
/* 荣誉图片注释设置 */
.slideImg {
  width: 100%;
  height: 450px;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}
@media (max-width: 768px) {
  .slideImg {
    height: 170px;
  }
  .slideP {
    font-size: 13px;
    line-height: 24px;
  }
}
.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyzz/top5.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 28px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
  z-index: 99;
  width: 1150px;
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 10px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 19px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}
/* 图片 */
.seboxlist {
  margin: 10px;
  padding: 30px;
  border: solid 1px #000;
  box-shadow: 10px 10px 5px #888888;
}
.row .area img {
  width: 100%;
  height: 224px;
}
.row .area .cmn {
  height: 500px;
}
/* 自定义 */
.seboxTitle {
  font-size: 35px;
  font-weight: 500;
  margin-top: 40px;
}
@media screen and (max-width: 768px) {
  .tabs {
    font-size: 1.75em;
  }
  .seboxTitle {
    font-size: 27px !important;
  }
  .seboxlist {
    margin: 5px;
    padding: 5px;
  }
  .row .area .cmn {
    height: 224px !important;
  }
  .row .area p {
    font-size: 15px;
  }
}
/* 小标题 */
.top .it-ico {
  margin-top: 5px;
  height: 65px;
  border-bottom: 1px #990000 solid;
  background: url(@/components/img/hyzz/titleico.gif) no-repeat left center;
  float: left;
  display: block;
  font-size: 12px;
  color: #cccccc;
}
.top .it-ico .t1 {
  padding-left: 40px;
  padding-top: 20px;
  color: #cccccc;
  line-height: 20px;
}
.top .it-ico .t1 .t2 {
  font-size: 25px;
  color: #333333;
  font-family: '微软雅黑';
}
/* 图片动画 */
body section#coidea {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  height: 100vh;
  overflow: hidden;
  padding: 20px;
}

body section#coidea .grid {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

body section#coidea .grid .grid-item {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  height: 100vh;
  overflow: hidden;
  padding: 32px 0;
}

body section#coidea .grid .grid-item .image {
  position: relative;
  display: block;
  width: 90%;
  /* max-width: 640px; */
  height: auto;
  overflow: hidden;
  float: left;
}

body section#coidea .grid .grid-item .image img {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
}

body section#coidea .grid .grid-item .content {
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  padding-left: 60vw;
  overflow: hidden;
  float: left;
}

body section#coidea .grid .grid-item .content h2 {
  /* text-transform: uppercase; */
  letter-spacing: 2px;
  opacity: 0;
}

/* effect-first */

body section#coidea.effect-1st {
  background: #121212;
}

body section#coidea.effect-1st .grid .grid-item .image .overlay {
  background-color: #121212;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

body section#coidea.effect-1st .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 50px;
  padding: 32px 0;
  color: #f8f8f8;
  text-shadow: 0px 7px 15px #121212;
  background-color: #a56c41;
  font-family: '等线Light';
}
body section#coidea.effect-1st .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 100px;
}

/* effect-second */

body section#coidea.effect-2nd {
  background: #f8f8f8;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay1 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 0;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay2 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 33.3333%;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay3 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 66.6666%;
}

body section#coidea.effect-2nd .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 50px;
  padding: 32px 0;
  color: #121212;
  text-shadow: 0px 7px 15px rgba(165, 108, 65, 0.5);
  background-color: #f7ead7;
  font-family: '等线Light';
}
body section#coidea.effect-2nd .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 100px;
}
/* effect-third */

body section#coidea.effect-3rd {
  background: #121212;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay1 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 0;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay2 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 33.3333%;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay3 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 66.6666%;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .content h2 {
  font-size: 30px;
  line-height: 40px;
  padding: 32px 0;
  color: #f8f8f8;
  text-shadow: 0px 7px 15px rgba(34, 34, 34, 1);
  background-color: #a56c41;
  font-family: '等线Light';
}
body section#coidea.effect-3rd .grid .grid-item .content h2 span {
  font-size: 40px;
  line-height: 100px;
}
/* effect-fourth */

body section#coidea.effect-4th {
  background: #f8f8f8;
}

body section#coidea.effect-4th .grid .grid-item .image .overlay1 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 100%;
  left: -50%;
  top: -50%;
}

body section#coidea.effect-4th .grid .grid-item .content h2 {
  font-size: 64px;
  line-height: 72px;
  padding-top: 32px;
  color: #121212;
  text-shadow: 0px 7px 15px rgba(34, 34, 34, 0.15);
}

@media screen and (max-width: 992px) {
  body section#coidea .grid .grid-item .image img {
    height: 40vh;
  }
  body section#coidea .grid .grid-item {
    padding: 0 !important;
  }
  body section#coidea {
    height: auto;
    padding: 0;
  }
  body section#coidea .grid {
    width: 100% !important;
    padding: 10px;
  }
  body section#coidea .grid .grid-item {
    height: auto;
  }
  body section#coidea .grid .grid-item .image {
    max-width: 100%;
    max-width: calc(100% - 32px) !important;
  }
  body section#coidea .grid .grid-item .content {
    padding-left: 160px !important;
  }
  body section#coidea .grid .grid-item .content h2 {
    font-size: 16px !important;
    line-height: 20px !important;
    padding: 10px 0 !important;
  }
  body section#coidea .grid .grid-item .content h2 span {
    font-size: 16px !important;
    line-height: 50px !important;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 {
    font-size: 14px !important;
    line-height: 14px !important;
  }
  /* body section#coidea.effect-4th {
      height: 150vh;
  } */
}
/* 手风琴 */
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
#accordion {
  padding-left: 2px;
  padding-right: 8px;
  z-index: 1;
}
#accordion .panel {
  border: none;
  box-shadow: none;
}
#accordion .panel-heading {
  padding: 0;
  border-radius: 0;
  border: none;
}
#accordion .panel-title {
  padding: 0;
}
#accordion .panel-title a {
  display: block;
  font-size: 16px;
  font-weight: bold;
  background: #f7ead7;
  color: #000;
  padding: 15px 25px;
  position: relative;
  margin-left: -24px;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a.collapsed {
  background: #a56c41;
  color: #fff;
  margin-left: 0;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a:before {
  content: '';
  border-left: 24px solid #f7ead7;
  border-top: 24px solid transparent;
  border-bottom: 24px solid transparent;
  position: absolute;
  top: 0;
  right: -24px;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a.collapsed:before {
  border-left-color: #a56c41;
}
#accordion .panel-title a:after {
  content: '\f106';
  position: absolute;
  font-family: 'FontAwesome';
  top: 30%;
  right: 15px;
  font-size: 18px;
  color: #000;
}
#accordion .panel-title a.collapsed:after {
  content: '\f107';
  color: #fff;
}
#accordion .panel-collapse {
  position: relative;
}
#accordion .panel-collapse.in:before {
  content: '';
  border-right: 24px solid #f7c59f;
  border-bottom: 18px solid transparent;
  position: absolute;
  top: 0;
  left: -24px;
}
#accordion .panel-body {
  font-size: 14px;
  color: #333;
  background: #e4e4e4;
  border-top: none;
  z-index: 1;
  padding: 15px 0 !important;
}
#accordion .panel-body p {
  font-size: large;
}
#accordion .panel-body img {
  width: 100%;
  height: 470px;
}
@media screen and (max-width: 768px) {
  .content-wrap section {
    margin-top: 10px;
  }
  .seboxp p {
    font-size: 15px;
  }
  #accordion .panel-body img {
    width: 100%;
    height: 150px;
  }
  #accordion .panel-body p {
    font-size: 14px;
  }
}
@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem {
    width: 1500px;
  }
  .zzitem li a {
    margin: 0 20px;
    font-size: 25px;
  }
  .seboxp p {
    font-size: 30px;
  }
  .seboxTitle {
    font-size: 40px;
  }
  body section#coidea.effect-1st .grid .grid-item .content h2 {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-2nd .grid .grid-item .content h2 {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 span {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 {
    font-size: 40px;
    line-height: 50px;
  }
  .row .area .cmn {
    height: 706px;
  }
  .row .area img {
    height: 330px;
  }
  .slideh2 {
    font-size: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .slideImg {
    height: 500px;
  }
  .slideP {
    font-size: 25px;
    line-height: 35px;
    padding-top: 20px;
  }
}
</style>
